import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IonInput, ModalController } from '@ionic/angular';
import format from 'date-fns/format';
import { Presenza } from 'src/app/models/rilevazione-presenze/presenza';
import { RichiestaDiConferma } from 'src/app/models/rilevazione-presenze/richiesta-conferma';
import { Rilevazione } from 'src/app/models/rilevazione-presenze/rilevazione';
import { ConfermaPresenza } from 'src/app/models/rilevazione-presenze/conferma-presenza';


@Component({
    selector: 'app-modifica-presenza',
    templateUrl: './modifica-presenza.component.html',
    styleUrls: ['./modifica-presenza.component.scss'],
    standalone: false
})
  export class ModificaPresenzaComponent implements OnInit {

    @Input() rilevazione: Rilevazione;
    @Input() presenza: Presenza;
    @Input() richiestaConferma: RichiestaDiConferma;
    @ViewChild('ora') ora: IonInput;

    form: FormGroup;
    maxTimeRil = new Date();
    minTimeRil = new Date();
    validCheck = true;

    constructor(
        private modalCtrl: ModalController,
        private formBuilder: FormBuilder
    ) {
        this.form = this.formBuilder.group({
            istanteMarcatura: [
                Validators.required
            ],
        });
    }

    ngOnInit() {
        this.maxTimeRil = new Date(this.rilevazione.istanteCreazione);
        this.maxTimeRil.setMinutes(this.maxTimeRil.getMinutes() + this.rilevazione.durata);

        this.minTimeRil = new Date(this.rilevazione.istanteCreazione);
        let val;
        if (this.richiestaConferma) {
            val = format(new Date(this.richiestaConferma.istanteRichiesta), 'HH:mm');
        } else {
            const im =  new Date(this.presenza.istanteMarcatura);
            // aggiunge 1 minuto per far si che la marcatura venga registrata il minuto dopo l'inizio della rilevazione
            im.setMinutes(im.getMinutes() + 1);
            val = format(im, 'HH:mm');
        }
        this.form.controls['istanteMarcatura'].setValue(val);
    }

    async annulla() {
        await this.modalCtrl.dismiss(null, 'cancel');
      }

    checkData(event: any) {
        console.log('this.rilevazione.istanteCreazione.toString()', this.rilevazione.istanteCreazione.toString());
        const date = this.rilevazione.istanteCreazione.toString().split('T');
        const chosenData = new Date(date[0] + 'T' + event.detail.value);
        console.log('minTimeRil', this.minTimeRil);
        console.log('chosenData', chosenData);
        console.log('maxTimeRil', this.maxTimeRil);
        if (chosenData.getTime() < this.minTimeRil.getTime() || chosenData.getTime() > this.maxTimeRil.getTime()) {
            this.validCheck = false;
        } else {
            this.validCheck = true;
        }
    }

    async saveModifiche() {
        const date = this.rilevazione.istanteCreazione.toString().split('T');

        if (this.richiestaConferma) {

            const cp: ConfermaPresenza = {
                'richiestaConferma': this.richiestaConferma,
                'idStudente': this.presenza.idStudente,
                'idRilevazione': this.rilevazione.id,
                'istanteConferma': new Date(date[0] + 'T' + this.form.get('istanteMarcatura').value)
            };
            this.presenza.confermaPresenza = cp;
        } else {
            this.presenza.istanteMarcatura = new Date(date[0] + 'T' + this.form.get('istanteMarcatura').value);
        }

        await this.modalCtrl.dismiss(this.presenza, 'cancel');
    }

    async openOraPicker() {
        (await this.ora.getInputElement()).showPicker();
      }
  }
